import type { CompanyEvents, CompanyEventsRequest } from "@/modules/companies/client/api/types"

import { getApiUrl } from "@/modules/api/api"
import { keysToCamelCase } from "@/modules/apiRequests/dataStructure"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

export const COMPANY_EVENTS_QUERY_KEY = "companies::company::events"
export const COMPANY_EVENTS_ENDPOINT = "/jobteaser.company.events.v1alpha1/EventsService/CompanyEvents"

export const getCompanyEvents = async (params: CompanyEventsRequest): Promise<CompanyEvents> => {
  const { nextRequest, ...restParams } = params
  return fetcher(
    getApiUrl({ path: COMPANY_EVENTS_ENDPOINT }),
    {
      body: JSON.stringify(restParams),
      method: "POST",
    },
    {
      nextRequest,
      serviceDomain: "GATEWAY_API",
    }
  )
    .then(getResultFromResponse<CompanyEvents>({ transformResult: keysToCamelCase<CompanyEvents> }))
    .catch(handleFetchError(COMPANY_EVENTS_ENDPOINT))
}
